
import { Component, OnInit , ViewChild} from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';


@Component({
  selector: 'app-ContactUs',
  templateUrl: './ContactUs.component.html',
  styleUrls: ['./ContactUs.component.css']
})
export class ContactUsComponent implements OnInit {




  constructor() { }

  ngOnInit(): void {



}
}



// WEBPACK FOOTER //
// ./src/app/home/ContactUs/ContactUs.component.ts